import { render, staticRenderFns } from "./list_gtjy.vue?vue&type=template&id=5cf8a6e0&scoped=true"
import script from "./list_gtjy.vue?vue&type=script&lang=js"
export * from "./list_gtjy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf8a6e0",
  null
  
)

export default component.exports